import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid2 as Grid,
  IconButton,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DOMPurify from "dompurify";
import { marked } from "marked";
import parse from "html-react-parser";
import { GET_QUESTIONNAIRE } from "../gql";
import { PREONBOARDING_ITEMS } from "../../Preonboarding/preonboardingData";
import LoadingCircle from "../../../../components/LoadingCircle";
import ErrorLayout from "../../../../components/layout/ErrorLayout";

const fieldByItemId: Record<string, string> = {
  "okenko-o-seznamu": "preonboardingText",
  "firemni-kultura": "preonboardingText2",
  "tvuj-tym-kontakty": "preonboardingText3",
};

const QuestionnairePreonboardingDetail = () => {
  const { id, preonboardingId } = useParams<{
    id: string;
    preonboardingId: string;
  }>();

  const { data, loading, error } = useQuery(GET_QUESTIONNAIRE, {
    variables: { questionnaireId: id ? parseInt(id) : "" },
  });

  if (loading) return <LoadingCircle />;
  if (error) return <ErrorLayout errorMsg={error.message || ""} />;

  const questionnaire = data?.questionnaire;
  const item = PREONBOARDING_ITEMS.find((i) => i.id === preonboardingId);
  const fieldName = preonboardingId ? fieldByItemId[preonboardingId] : null;
  const text = fieldName ? questionnaire?.[fieldName] : null;

  if (!item || !text) {
    return (
      <ErrorLayout errorMsg="Vybraný obsah preonboardingu nebyl nalezen." />
    );
  }

  return (
    <Container maxWidth="md">
      <Grid container>
        <Grid size={{ xs: 12 }}>
          <IconButton onClick={() => window.history.back()}>
            <ArrowBackIcon />
          </IconButton>

          <Typography variant="h4" mb={1}>
            {item.title}
          </Typography>
          <Typography mb={2}>{item.subtitle}</Typography>

          <Card variant="outlined">
            <CardContent>
              <Box px={4}>{parse(DOMPurify.sanitize(marked(text, { async: false }) as string))}</Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default QuestionnairePreonboardingDetail;
